// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"VX-z","smallCardRow":"WX-z","largeCardRow":"XX-z","productSearchRow":"YX-z","curatedRow":"ZX-z"};